export default class AccessManagementController {

}



// WEBPACK FOOTER //
// ./app/common/access-management/access.controller.js